<template>
    <div v-show="isAddNewAccountLicenseModalVisible">
        <transition name="slide">
            <div :class="type == 2 ? 'modal-mask' : 'modal-mask1'">
                <div class="modal-dialog modal-dialog-slideout modal-lg max-width-100">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="width-100">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                        <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h3 d-inline mr-2 text-uppercase">Purchase</div>
                              
                            </div>
                          </div>                            
                            <form>
                                <div class="row mt-2">
                                    <div class="col-12">
                                        <div class="row">
                          <div class="col-6">
                            <label class="form-label">Subscription Type</label>
                          </div>
                          <div class="col-3">
                            <label class="form-label text-center width-100">Quantity</label>
                          </div>
                          <div class="col-3">
                            <label class="form-label text-center width-100">Price</label>
                          </div>
                        </div>
                        <div class="row row_data_border" v-for="(pitem, sindex) in subscriptions" :key="sindex">
                          <div class="col-6">
                            <label :for="'subscription_plan_' + sindex">{{ pitem.name }}</label>
                          </div>
                          <div class="col-3">
                            <b-form-select class="col-12 col-sm-12 input-height-35 form-control" v-model="unit" name="unit" :options="qty_options" placeholder="Qty" @change="getPriceforSubscription">           
                            </b-form-select>
                          </div>

                        <div class="col-3 col-sm-3" v-if="type == 'monthly'">
                            <label for="" class="width-100 text-center"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/monthly</label>
                        </div>
                        <div class="col-3 col-sm-3" v-else-if="type == 'yearly'">
                            <label for="" class="width-100 text-center"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/annually</label>
                        </div>
                        <div class="col-3 col-sm-3" v-else>
                            <label for="" class="width-100 text-center"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/{{ pitem.duration }}</label>
                        </div>
                        </div>
                        <div v-if="verrors.firstByRule('subscription_plan', 'required')" class="margin-bottom-5 validate-warning-msg">Subscription Type is required</div>
                        <div class="row">
                          <div class="col-9 text-right pr-0" style="padding-top: 8px;">
                            Prorated
                          </div>
                          <div class="col-3 col-sm-3 text-right padding-r-45">
                            <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                              Total: <span class="total_price">${{ subscriptionTotal }}</span>
                            </button>
                          </div>
                        </div>

                    </div>
                </div>


                                <div class="row mt-4" v-if="type != 'monthly'">
                                    <div class="col-12">
                                        <label class="form-label">Billing Information</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12">      
                            <input
                                type="text"
                                id="bname"
                                class="col-12 col-sm-12 input-height-35 form-control"
                                ref="bname"
                                name="bname"
                                v-model="billingName"
                                v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                                placeholder="Billing Name"
                                maxlength="250"
                                autocomplete="off"
                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                                                <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: 10px;">
                                            <div class="col-12 col-sm-12">
                                                <b-form-select
                                                class="col-12 col-sm-12 input-height-35 form-control"
                                                id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                                                :options="country_options"
                                                v-on:change="getStateLists(billingCountry)"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>
                                                <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                                            </div>
                                            <div class="col-12 col-sm-12" style="margin-top: 10px;">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_address_1" 
                                                    placeholder="Billing Address 1" 
                                                    v-model="billingAddress" 
                                                    v-validate="'required'"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                                            </div>                 
                                            <div class="col-12 col-sm-12" style="margin-top: 10px;">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_address_2" 
                                                    placeholder="Billing Address 2" 
                                                    v-model="billingAddress2" 
                                                    >
                                                
                                            </div>                                                       
                                            <div class="col-12 col-sm-12" style="margin-top: 10px;">
                                                <input 
                                                type="text" 
                                                name="phone number" 
                                                id="phone_number"
                                                ref="phone_number"
                                                v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                                v-model="billingPhone"
                                                @keyup="billingPhoneValid"
                                                @blur="billingPhoneValid"
                                                class="col-12 col-sm-12 input-height-35 form-control" 
                                                placeholder="Phone Number"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: 10px;">
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_city" 
                                                    placeholder="City" 
                                                    v-model="billingCity" 
                                                    v-validate="'required'"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <b-form-select
                                                class="col-12 col-sm-12 input-height-35 form-control"
                                                name="billing_state" v-model="billingState" v-validate="'required'"
                                                :options="state_options"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>    
                                                <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                type="text" 
                                                name="zip code" 
                                                id="org_zip"
                                                ref="org_zip"
                                                v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                                v-model="billingZip"
                                                maxlength="10"
                                                class="col-12 col-sm-12 input-height-35 form-control" 
                                                placeholder="Zip"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4"  v-if="type != 'monthly'">
                                    <div class="col-12">
                                        <label class="form-label">Credit/Debit Card Information</label>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="card_no" 
                                                            v-model="cardNumber" 
                                                            v-validate="'required'"
                                                            placeholder="Credit Card #"
                                                            :disabled="(isAccessPlan) ? false: true">
                                                        <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top: 10px;">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="name_on_card" 
                                                            v-model="nameOnCard" 
                                                            v-validate="'required'"
                                                            placeholder="Name on Card"
                                                            :disabled="(isAccessPlan) ? false: true">
                                                        <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top: 10px;">
                                                    <div class="col-4 col-sm-4">
                                                        <select 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="exp_month" 
                                                            v-model="expMonth" 
                                                            v-validate="'required'"
                                                            :disabled="(isAccessPlan) ? false: true">
                                                            <option value="">Month</option>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                                    </div>
                                                    <div class="col-4 col-sm-4">
                                                        <b-form-select
                                                            class="col-12 col-sm-12 input-height-35 form-control"
                                                            name="exp_year" 
                                                            v-model="expYear" 
                                                            v-validate="'required'"
                                                            :options="year_options"
                                                            :disabled="(isAccessPlan) ? false: true">
                                                        </b-form-select>
                                                        <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                                    </div>
                                                    <div class="col-4 col-sm-4">

                  <input 
                    type="password" 
                    class="col-12 col-sm-12 input-height-35 form-control" 
                    name="cvv" 
                    placeholder="CVV"
                    v-model="cvvValue" 
                    v-validate="'required'"
                    :disabled="(isAccessPlan) ? false: true"
                    role="presentation"
                    autoComplete="new-password">

                             
                                                        <div v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg">CVV is required</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center m-4">
                                    <button type="button" class="btn btn-sm ma-blue-btn text-center" @click="onSubmit">
                                        Purchase
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <AddNewAccountLicenseSuccessModal 
            :isAddNewAccountLicenseSuccessModalVisible="isAddNewAccountLicenseSuccessModalVisible"
            :accountId="accountId"
            :invoice_filename="invoice_filename"
            :total="total"
            :cc4_digit="cc4_digit"
            :type="type"
            ref="active_account_order"
            @close="close"
        />

        <AddNewAccountLicenseFailedModal
            :isAddNewAccountLicenseFailedModalVisible="isAddNewAccountLicenseFailedModalVisible"
            :type="type"
            landingPage="locations"
            @close="close"
        />

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';

import AddNewAccountLicenseSuccessModal from './add_new_account_license_success_modal.vue';
import AddNewAccountLicenseFailedModal from './add_new_account_license_failed_modal.vue';

Vue.filter('formatExpirationDate', function(value) {
    if (value) {
        return moment(String(value)).format('MMMM Do, YYYY')
    } else {
        return 'n/a';
    }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isAddNewAccountLicenseModalVisible', 'accountId', 'type'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            account_groups: '',
            account_groups_options: [],
            newAccountId: '',
            invoice_filename: '',
            cc4_digit: '',
            total: '',
            close_url: '',
            country_options: [],
            state_options: [],
            accountNames: [],
            isAddNewAccountLicenseSuccessModalVisible: false,
            isAddNewAccountLicenseFailedModalVisible: false,
            unit: 1,
            qty_options: [
              { value: '', text: 'Select' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            licenseType: '',
            unitType: '',
            description: '',
            seat_qty_options: [
              { value: '', text: 'Select' },
              { value: 5, text: 5 },
              { value: 10, text: 10 },
              { value: 15, text: 15 },
              { value: 20, text: 20 },
            ],
            totalLicense: '',
            usedLicense: '',
            accountExpire: '',
            type: '',
            originalPrice: '',
            seatMaxQty: '',
        }
    },
    components: {
        AddNewAccountLicenseSuccessModal,
        AddNewAccountLicenseFailedModal,
    },
    methods: {
        hide() {
            this.close();
        },
        close() {
            this.verrors.clear();
            this.subscription_plan = '';
            this.billingName = '';
            this.billingAddress = '';
            this.billingAddress2 = '',
            this.billingCity = '';
            this.billingState = '';
            this.billingCountry = '';
            this.billingZip = '';
            this.billingPhone = '';
            this.nameOnCard = '';
            this.cardNumber = '';
            this.expMonth = '';
            this.expYear = '';
            this.cvvValue = '';
            this.subscriptionTotal = 0;
            this.$parent.closeAddSubscriptionModal();
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
        setSubscriptionTotal(item) {
            this.subscriptionId = item.id;
            this.subscriptionTotal = item.price;
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    this.createAccount();
                }
            });
        },
        getPriceforSubscription: function() {
        if(this.unit > 0) {                  axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.accountId,
              }
            }
          )
          .then(response => {
              this.subscriptions[0].price = response.data;
              if(this.unitType == 'Seat') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionTotal = this.subscriptions[0].price * this.unit;
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
          }
        },
        getSubscriptionLists() {
            axios.get('/active-subscriptions/' + this.accountId + '/Single')
            .then((resp) => {
                this.loading = false;
                this.seatMaxQty = resp.data.seatMaxQty;
                this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
                this.subscriptions = resp.data.subscriptions;
                this.type = resp.data.type;
                this.totalLicense = resp.data.totalLicense;
                this.usedLicense = resp.data.usedLicense;
                this.accountExpire = resp.data.accountExpire;
                this.subscriptions = resp.data.subscriptions;
                this.subscriptionId = this.subscriptions[0].id;
                this.unitType = this.subscriptions[0].name;
                this.licenseType = this.subscriptions[0].licenseType;
                this.description = this.subscriptions[0].description;
                this.unit = this.subscriptions[0].minQty;
                if(this.maxAdditionalSeatLimit != '') {
                  this.qty_options = [];
                  var qty =  { value: '', text: 0 };
                  this.qty_options.push(qty);
                  for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                      var qty = {value: i, text: i};
                      this.qty_options.push(qty);
                  }
                }
                if((this.unit > 1)) {
                    this.qty_options = [];
                    var qty =  { value: '', text: 'Please select' };
                    this.qty_options.push(qty);
                    for(var i=this.unit; i < 21; i++) {
                        var qty = {value: i, text: i};
                        this.qty_options.push(qty);
                    }
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else if(this.subscriptions[0].name == 'Seat') {
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else {
                    this.subscriptionTotal = this.subscriptions[0].price * this.unit;
                }
                this.subscriptionPrice = this.subscriptions[0].price;
                
            })
            .catch(error => {

            });
        },
        createAccount() {
            axios('/enterprise-admin/renew-account-license/' + this.accountId, 
            {
                method: 'POST',
                data: {
                    "order": {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.subscriptionPrice,
                        "unit": this.unit,
                        "description": this.description,
                        "total": this.subscriptionTotal,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": 'credit_card',
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                        "first_time_subscription": true,
                    }
                },
            })
            .then((response) => {
                this.verrors.clear();
                if (response.data.order_msg != 'failed') {
                    this.$refs.active_account_order.invoice_filename = response.data.invoice_filename;
                    this.isAddNewAccountLicenseSuccessModalVisible = true;
                    this.$refs.active_account_order.total = response.data.total;
                    this.$refs.active_account_order.cc4_digit = response.data.ccNumber4digit;
                } else {
                    this.isAddNewAccountLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                console.log(error)
            });
        },
        loadInitialData() {
            this.verrors.clear();
            this.getCountryLists();
            this.getStateLists('US');
            this.getSubscriptionLists();
            this.getExpiryYears();
        },
        formatSubscriptionYear(no_of_years) {
            var display_year = "";
            if (no_of_years == 1) {
                display_year += "Year";
            } else {
                display_year += no_of_years + " Years";
            }
            return display_year;
        },
    },
    created() {
    }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}

.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.ma-blue-btn {
  color: #FFF; 
  border-radius: 10px;
  font-weight: 900;
  width: auto;
}
.totalBtn, .totalBtn.btn-blue {
  color: #002F42; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 10px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;   
  background-color: #efefef;
  min-height: 38px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.res_offcanvas_content { float: left; margin: 5px 0; font-weight: 500; }
.license_heading_1 { width: 55%; }
.license_heading_2 { width: 30%; }
.license_heading_3 { width: 15%; }
.planBtn, .planBtn:focus, .planBtn:active, .planBtn:hover {
  color: #000 !important;
  background: #a1ee95 !important;
  border: 1px solid #a1ee95 !important;
  border-radius: 5px;
  width: 150px;
}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}
.max-width-100 {
    max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_account_license.vue